import React from "react";
function LeftLeaf(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-127.76 39.07 361.12 362.81"
        {...props}
      >
        <path
          d="M-60.678 141.634l-7.963 21.447c29.335 45.936 63.11 83.923 97.235 115.022l11.913-38.616 1.466 50.454c96.524 82.856 191.385 111.934 191.385 111.934-8.177-41.094-19.758-77.541-33.772-109.902l-27.882 1.797 22.919-12.826C144.51 172.798 66.81 112.61.211 79.36l-24.95 11.372L-8.583 75.07C-74.73 43.849-127.764 39.068-127.764 39.068c13.781 41.238 31.93 80.185 54.143 116.194l12.943-13.628z"
          fill="#0D3727"
        />
        <path
          d="M-117.562 45.94s250.706 168.087 344.306 347.358c0 0-74.209-142.389-344.306-347.358zM-38.427 108.677L8.34 94.283l-42.284 15.575-4.483-1.181z"
          fill="#0D5137"
        />
        <path
          d="M5.711 146.331l16.959 81.307-11.85-79.225-5.109-2.082zM43.08 177.261l59.822-6.31-54.891 9.11-4.931-2.8zM103.079 236.009l18.357 71.217-22.654-76.229 4.297 5.012zM145.305 276.889l33.48-1.117-33.188 4.474-.292-3.357zM173.341 317.476l3.764 27.301.269-28.266-4.033.965z"
          fill="#0D5137"
        />
      </svg>
    );
  }

  export default LeftLeaf;